import { Patient, PatientGroupAssignmentSetCommand, PatientQuery } from '@dreryk/egabinet-patient-frontend-api';
import { PatientId } from '@dreryk/egabinet-patient-published-language-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionBar, ButtonVariant, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';
import { commonTranslationKeys } from '@dreryk/react-common';

import { translationKeys } from '../translations';

import {
   PatientGroupsAssignmentsFormBean,
   PatientGroupsAssignmentsFormController,
} from './form/PatientGroupsAssignmentsForm.types';

type PatientGroupsSaveActionProps = Pick<PatientGroupsAssignmentsFormController, 'handleSubmit'> &
   Readonly<{ patientId: Patient['id'] }>;

export const PatientGroupsAssignmentsSaveAction = (props: PatientGroupsSaveActionProps): JSX.Element => {
   const { executeAsync: setPatientGroupAssignment } = useCqrsCommand<void, PatientGroupsAssignmentsFormBean>(
      (parameters) => {
         const command = new PatientGroupAssignmentSetCommand();
         command.patientId = PatientId.of(props.patientId);
         command.patientGroupIds = parameters.patientGroups.map(({ id }) => id);
         return command;
      },
      {
         onSuccess: () => {
            refetchCqrsQuery(PatientQuery);
            dispatchSnackbarPositiveEvent(translationKeys.changesHaveBeenSaved);
         },
      }
   );
   return (
      <ActionBar.PrimaryButton
         variant={ButtonVariant.PRIMARY}
         onClick={props.handleSubmit(setPatientGroupAssignment)}
         label={commonTranslationKeys.save}
         testId={'savePatientGroupsAssignment'}
         blockingOperation
      />
   );
};
